const MapLayerTypes = [
  {
    id: 1,
    name: "WFS - Web Feature Service (2.0)",
  },
  {
    id: 2,
    name: "WMS - Web Map Service",
  },
  {
    id: 3,
    name: "WMTS - Web Map Tile Service",
  },
  {
    id: 4,
    name: "VTL - Vector Tile Layer",
  },
];

export default MapLayerTypes;
